/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="76.93"
        height="95.61"
        viewBox="0 0 76.93 95.61"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M25.62 8.88a11 11 0 0 1 11 10.62v6.43a1.27 1.27 0 0 1-1.28 1.23 1.24 1.24 0 0 1-1.21-1.1v-6.24a8.44 8.44 0 0 0-16.87-.58 5.61 5.61 0 0 0 0 .58 1.25 1.25 0 0 1-2.5 0A11 11 0 0 1 25.62 8.88ZM9.32 72.77a1.25 1.25 0 0 1 1.25 1.25 10.21 10.21 0 0 0 9.9 10.18h5.15a8.28 8.28 0 0 0 4.8-1.51 1.25 1.25 0 0 1 1.43 2 10.76 10.76 0 0 1-5.83 2h-5.29A12.7 12.7 0 0 1 8.05 74.01a1.25 1.25 0 0 1 1.27-1.24Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M18.89 77.6a1.25 1.25 0 0 1 0 2.5 3.34 3.34 0 0 0-3.33 3.33 1.25 1.25 0 1 1-2.5 0 5.84 5.84 0 0 1 5.83-5.83ZM13.35 58.78a1.26 1.26 0 0 1 1.22 1.28 1.24 1.24 0 0 1-1.09 1.21H9.9a5.41 5.41 0 0 0-.21 10.81H21.1a1.26 1.26 0 0 1 1.22 1.28 1.24 1.24 0 0 1-1.09 1.21H9.9a7.91 7.91 0 0 1-.24-15.82h3.69Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M10.26 46.23a1.26 1.26 0 0 1 1.22 1.28 1.24 1.24 0 0 1-1.09 1.21h-3.4a5.001 5.001 0 1 0-.21 10h6.55A1.26 1.26 0 0 1 14.55 60a1.24 1.24 0 0 1-1.09 1.21H6.99a7.53 7.53 0 0 1-.24-15h3.49Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M14.76 31.59a1.26 1.26 0 0 1 1.22 1.28 1.24 1.24 0 0 1-1.09 1.21h-5.2a6.07 6.07 0 0 0-.23 12.13h.8a1.26 1.26 0 0 1 1.22 1.28 1.24 1.24 0 0 1-1.09 1.21h-.7a8.571 8.571 0 1 1-.26-17.14h5.33Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M21.29 18.81a7.68 7.68 0 0 1 7.64 7.69 1.25 1.25 0 1 1-2.5 0 5.18 5.18 0 0 0-4.93-5.13h-6.74a5.14 5.14 0 1 0 0 10.28 1.25 1.25 0 0 1 0 2.5 7.64 7.64 0 0 1-.25-15.27h6.78ZM51.19 8.88a11 11 0 0 1 10.94 10.94 1.25 1.25 0 0 1-2.5 0 8.42 8.42 0 0 0-13.64-6.63 1.27 1.27 0 1 1-1.55-2 10.9 10.9 0 0 1 6.75-2.31ZM41.51 66.92a1.27 1.27 0 0 1 1.24 1.12v7.72a8.46 8.46 0 0 0 8.24 8.44h5.1a10.22 10.22 0 0 0 10.18-10.18 1.25 1.25 0 1 1 2.5 0A12.74 12.74 0 0 1 56.39 86.7h-5.2a11 11 0 0 1-10.93-10.65v-7.88a1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M57.99 77.6a5.86 5.86 0 0 1 5.84 5.83 1.25 1.25 0 1 1-2.5 0 3.37 3.37 0 0 0-3.34-3.33 1.25 1.25 0 0 1 0-2.5ZM66.93 58.78a7.91 7.91 0 0 1 .25 15.81H55.73a1.25 1.25 0 0 1-1.25-1.25 1.27 1.27 0 0 1 1.13-1.25h11.32a5.411 5.411 0 0 0 .22-10.82h-3.67a1.25 1.25 0 0 1-1.25-1.25 1.27 1.27 0 0 1 1.13-1.25h3.57Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M69.82 46.23a7.52 7.52 0 0 1 .24 15h-6.58a1.25 1.25 0 0 1-1.25-1.25 1.27 1.27 0 0 1 1.13-1.25h6.46a5.001 5.001 0 1 0 .22-10h-3.42a1.24 1.24 0 0 1-1.25-1.23 1.27 1.27 0 0 1 1.13-1.25h3.37Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M67.14 31.59a8.57 8.57 0 0 1 .26 17.13h-.78a1.24 1.24 0 0 1-1.25-1.22 1.27 1.27 0 0 1 1.13-1.25h.69a6.071 6.071 0 0 0 .23-12.14h-5.29a1.26 1.26 0 1 1-.09-2.51h5.15Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M62.08 18.81a7.64 7.64 0 0 1 0 15.28 1.25 1.25 0 0 1 0-2.5 5.14 5.14 0 0 0 .21-10.27h-6.74a5.15 5.15 0 0 0-5.14 5.18 1.25 1.25 0 1 1-2.5 0 7.65 7.65 0 0 1 7.39-7.63h6.78Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="m48.62 1.5-7.56 38.42 15.46-5.33a1.26 1.26 0 0 1 1.58 1.61v.1L30.22 94.86a1.25 1.25 0 0 1-1.66.62 1.24 1.24 0 0 1-.72-1.27v-.13l8.26-42-15.59 6.46a1.24 1.24 0 0 1-1.65-1.59v-.11L46.27.69a1.24 1.24 0 0 1 1.66-.58 1.27 1.27 0 0 1 .71 1.24Zm-4.3 8.92-21.7 44.56 14.72-6.11a1.25 1.25 0 0 1 1.61.73 1.27 1.27 0 0 1 .08.55v.15l-6.81 34.5L54.5 37.92 39.8 43a1.24 1.24 0 0 1-1.65-1.31v-.12Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'BrainWithLightningBoltIcon';

export default Icon;
